import { useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import { getFolderChildren } from "../api/folders.api";
import { folderTreeQueryKey } from "./useFolderTree";
import type { FolderChildrenResponse } from "../types/project-storage.types";
import { mapStorageError } from "../utils/storageErrors";

export const folderChildrenQueryKey = (mmCode: number, folderId: string) =>
  ["storage-children", mmCode, folderId] as const;

export function useFolderChildren(
  mmCode: number | null,
  folderId: string | null
) {
  const queryClient = useQueryClient();

  return useQuery<FolderChildrenResponse>({
    queryKey: folderChildrenQueryKey(mmCode ?? 0, folderId ?? ""),
    queryFn: () =>
      getFolderChildren(mmCode as number, folderId as string),
    enabled: mmCode !== null && !!folderId,
    staleTime: 15_000,
    onError: (error: unknown) => {
      const mapped = mapStorageError(error, "navigation");

      if (mapped.errorCode === "FOLDER_NOT_FOUND") {
        toast.error(mapped.message);
        if (mmCode !== null) {
          queryClient.invalidateQueries(folderTreeQueryKey(mmCode));
        }
        return;
      }

      if (mapped.errorCode === "PROJECT_NOT_FOUND") {
        toast.error(mapped.message);
        return;
      }

      toast.error(mapped.message);
    },
  });
}
